import React from 'react'
import SEO from '../components/SEO.jsx';
import Header from "../partials/header/Header.jsx";
import Breadcrumb from '../container/Breadcrumb/Breadcrumb.js';
import Footer from '../container/Footer/Footer.js';
import ScrollToTop from '../components/ScrollToTop.jsx';
import './CareerContentone.css';
const CareerContentTwo= () => {
  return (
    <React.Fragment>
    <SEO title="Thirumala || Career > Career Corporate Division" />
    <Header />
    <Breadcrumb 
        image="images/bg/cd.jpg"
        // title="We are an agency located in New York"
        title="Foundry Division"
        content="Home"
        contentTwo="Foundary Division"
    

    />
    <div className='no-career'>
   <div className='no-career-found'>
      <h1 className='career'>No Careers Found !</h1>
    </div>
    </div>
   
<Footer />
    <ScrollToTop />
</React.Fragment>
  )
}

export default CareerContentTwo;
